import { Component, OnInit } from '@angular/core';
import { SaPaypalServiceService } from '../../services/SaPaypalService.service';
import { Router } from '@angular/router';
import { NewPaypalTransactionModel } from '../../models/NewPaypalTransaction.model';
import { ErrorModel } from '../../../../shared/models/Error.model';

@Component({
  selector: 'app-paypal-transaction-history',
  templateUrl: './paypal-transaction-history.component.html',
  styleUrls: ['./paypal-transaction-history.component.css']
})
export class PaypalTransactionHistoryComponent implements OnInit {
  showOverlayPaypal: boolean = false;
  paypalMain: any;
  paypalTransactions: any[] = [];
  newPaypalTransactionModel: NewPaypalTransactionModel[];
  nextId: string;
  showMoreTransaction: boolean = false;
  searchTermPayPalTransaction: string = '';
  mainViewError = new ErrorModel();
  constructor(private _service: SaPaypalServiceService, private router: Router) { }

  ngOnInit() {

    this.newPaypalTransactionModel = [];
    this.getTransactions();
  }


  getTransactions() {
    this.showOverlayPaypal = true;

    this.mainViewError.display = false;
    this._service.getTransactions().subscribe(
    (data) => {
      this.paypalMain = data;
      if (this.paypalMain.count != 0) {
        this.paypalTransactions = this.paypalMain.payments;
        this.paypalTransactions.forEach(i => {
          let paypalEntry: NewPaypalTransactionModel = new NewPaypalTransactionModel();
          paypalEntry.date = i.createdDate;
          paypalEntry.name = i.payer.payer_info.first_name + ' ' + i.payer.payer_info.last_name;
          paypalEntry.payment = i.transactions[0].related_resources[0].sale.state;
          paypalEntry.gross = i.transactions[0].amount.total + ' ' + i.transactions[0].amount.currency;
          paypalEntry.fee = i.transactions[0].related_resources[0].sale.transaction_fee.value + ' ' + i.transactions[0].related_resources[0].sale.transaction_fee.currency;
          paypalEntry.net = (((i.transactions[0].amount.total - i.transactions[0].related_resources[0].sale.transaction_fee.value)));
          paypalEntry.productName = i.transactions[0].item_list.items[0].name;
          this.newPaypalTransactionModel.push(paypalEntry);
        });
        this.nextId = this.paypalMain.next_id;
      }
    },
    (error) => {
      this.mainViewError.error = error;
      this.mainViewError.display = true;

    }).add(() => {
      this.showOverlayPaypal = false;

    });
  }

  getMoreTransactions() {
    if (this.nextId !== null && this.nextId !== undefined) {
      this.showMoreTransaction = true;
      this._service.getMoreTransactions(this.nextId).subscribe(
      (data: any) => {
          let paypalMoreTransaction = data;
          this.nextId = paypalMoreTransaction.next_id;
          paypalMoreTransaction.payments.forEach((i) => {
            var paypalEntry: NewPaypalTransactionModel = new NewPaypalTransactionModel();
            paypalEntry.date = i.createdDate;
            paypalEntry.name = i.payer.payer_info.first_name + ' ' + i.payer.payer_info.last_name;
            paypalEntry.payment = i.transactions[0].related_resources[0].sale.state;
            paypalEntry.gross = i.transactions[0].amount.total + ' ' + i.transactions[0].amount.currency;
            paypalEntry.fee = i.transactions[0].related_resources[0].sale.transaction_fee.value + ' ' + i.transactions[0].related_resources[0].sale.transaction_fee.currency;
            paypalEntry.net = (((i.transactions[0].amount.total - i.transactions[0].related_resources[0].sale.transaction_fee.value)));
            paypalEntry.productName = i.transactions[0].item_list.items[0].name;
            this.newPaypalTransactionModel.push(paypalEntry);
          });
      }).add(() => {
        this.showMoreTransaction = false;

      });
    }

  }
}
